import {gql} from 'graphql-request';
import {saasFragment} from 'src/services/shared/Fragments';

export const connectedSaasesQuery = gql`
  query GetConnectedSaases($clientBoolExp: client_bool_exp) {
    client_saas (
      where: {
        saas: {}, # filter out disabled SaaSes
        client: $clientBoolExp
      }, 
      order_by: {saas: {name: asc}}
    ) {
      saas  {
        ...Saas
      }
      pub_id # the connection id
      nick_name
      latest_batch {
        raw_batch_start_time
        updated_ts
      }
    }
  }
  ${saasFragment}
`;

export const connectedSaasesDetailQuery = gql`
  query GetConnectedSaasDetails($clientBoolExp: client_bool_exp) {
    client_saas(
      where: {
        saas: {} # filter out disabled SaaSes
        client: $clientBoolExp
      }
      order_by: {saas: {name: asc}}
    ) {
      saas {
        ...Saas
      }
      secret_version {
        version
        type
      }
      pub_id # the connection id
      nick_name
      latest_batch {
        raw_batch_start_time
        updated_ts
      }
    }
  }
  ${saasFragment}
`;

// The SaaSes a client may add: client_visibility lists the clients a SaaS
// is shown to - every client for regular SaaSes, only the selected ones for
// custom (client-restricted) SaaSes.
export const getAllSaasQuery = gql`
  query AllSaas($clientId: uuid!) {
    saas (
      order_by: {name: asc},
      where: {client_visibility: {client: {pub_id: {_eq: $clientId}}}}
    ) {
      pub_id
      name
      description
    }
  }
`;
